import React, { useContext } from "react";
import "./CoreValues.css";
import { TeamContentContext } from "../../../Contexts/TeamContentContext";
import { DropMenu } from "../../../components/DropMenu/DropMenu";
import image from "../../../Assets/nosotros/7Fotoenmisionyvision/misionvisionpc.jpg";
function CoreValues() {
  const { coreValuesInfo } = useContext(TeamContentContext);
  return (
    <div className="valuesContainer top">
      <section className="sectionText" id="PROPÓSITO">
        <h2>{coreValuesInfo.proposito.title}</h2>
        <p>{coreValuesInfo.proposito.description}</p>
      </section>
      <section className="valueMainSection">
        <div className="textContainer">
          <h2>{coreValuesInfo.mision.title}</h2>
          <p>{coreValuesInfo.mision.description}</p>
          <h2 style={{ marginTop: 60 }}>{coreValuesInfo.vision.title}</h2>
          <p>{coreValuesInfo.vision.description}</p>
        </div>
        <div className="imageContainer">
          <img alt={"mision"} src={image} />
        </div>
      </section>

      <DropMenu title="Valores y principios ">
        <div className="valuesLists">
          <section>
            <h3>{coreValuesInfo.valores.title}</h3>
            <ul>
              {coreValuesInfo.valores.lista.map((item, index) => (
                <li key={`valores${index}`}>{item}</li>
              ))}
            </ul>
          </section>
          <section>
            <h3>{coreValuesInfo.principios.title}</h3>
            <ul>
              {coreValuesInfo.principios.lista.map((item, index) => (
                <li key={`principios${index}`}>{item}</li>
              ))}
            </ul>
          </section>
        </div>
      </DropMenu>
    </div>
  );
}

export { CoreValues };
